// Simple pub/sub for client updates so different parts of the UI can refresh
// automatically when one of them mutates a Client.
const EVENT_NAME = "client:updated";

export const emitClientUpdated = (client) => {
	if (!client || !client.id) return;
	window.dispatchEvent(
		new CustomEvent(EVENT_NAME, { detail: client })
	);
};

export const onClientUpdated = (handler) => {
	const listener = (e) => handler(e.detail);
	window.addEventListener(EVENT_NAME, listener);
	return () => window.removeEventListener(EVENT_NAME, listener);
};
